<dx-popup
  [(visible)]="visible"
  [showTitle]="false"
  [showCloseButton]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.3)"
  [width]="480"
  height="auto"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [wrapperAttr]="{ class: 'gpd-popup' }"
>
  <div class="complete-popup">
    <div class="complete-popup__icon-ring">
      <div class="complete-popup__icon">
        <i class="fas fa-check"></i>
      </div>
    </div>

    <h2 class="complete-popup__title"
        i18n="@@projectCompleteTitle">Congratulations {{firstName}}!</h2>
    <p class="complete-popup__subtitle"
       i18n="@@projectCompleteSubtitle">The project has been completed.</p>

    <div class="complete-popup__checklist">
      <div class="complete-popup__check-item">
        <i class="fas fa-check-circle"></i>
        <span i18n="@@projectCompleteTasksDone">All required tasks have been completed</span>
      </div>
      <div class="complete-popup__check-item">
        <i class="fas fa-check-circle"></i>
        <span i18n="@@projectCompleteCostsPaid">All costs have been settled</span>
      </div>
    </div>

    <div class="complete-popup__sustainability">
      <i class="fas fa-leaf"></i>
      <span i18n="@@projectCompleteSustainability">Another step towards sustainable energy</span>
    </div>

    <app-gpd-button
      type="primary"
      width="100%"
      i18n-text="@@continue"
      text="Continue"
      (onClick)="close()"
    ></app-gpd-button>
  </div>
</dx-popup>
